import React from 'react';
import styled from 'styled-components';

import {
  ColumnBlock,
  ColumnContent,
  ContentSection,
} from '../../../layout/components';

export const SplitSectionLeft = styled(ContentSection)`
  justify-content: flex-start;
`;

export const SplitSectionRight = styled(ContentSection)`
  justify-content: flex-end;
`;

export const BleedSectionLeft = styled(ContentSection)`
  justify-content: flex-start;
`;

export const BleedSectionRight = styled(ContentSection)`
  justify-content: flex-end;
`;

export const FigureBlock = styled(ColumnBlock).attrs({
  columns: 3,
})`
  //position: relative;
`;

export const FigureContainer = styled.div`
  width: 100%;
`;

export const SplitFigureBlock = styled(ColumnBlock).attrs({
  columns: 2,
})`
  position: relative;
`;

const MainFigureContainer = styled.div`
  width: 100%;
  padding-top: 54.4802867383513%;
  position: relative;
  z-index: 0;
  ${props =>
    props.breakpoint === 'phone' &&
    `
    margin-bottom: 2.25rem;
    `};
`;

export const SplitFigureContainer = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  ${props =>
    props.breakpoint === 'phone' &&
    `
    margin-bottom: 2.25rem;
  `};
`;

export const MainFigureContainerLeft = MainFigureContainer.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
  left: -1.875rem;
  padding-right: 1.875rem;
  `};
`;

export const MainFigureContainerRight = MainFigureContainer.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
    right: -1.875rem;
    padding-left: 1.875rem;
    float: right;
  `};
`;

export const SplitFigureContainerLeft = SplitFigureContainer.extend`
  left: -1.875rem;
  padding-right: 1.875rem;
  margin-bottom: 10rem;
`;

export const SplitFigureContainerRight = SplitFigureContainer.extend`
  right: -1.875rem;
  padding-left: 1.875rem;
  float: right;
  margin-bottom: 10rem;
`;

export const MainFigure = styled.figure`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export const SquareMainFigure = MainFigure.extend`
  padding-bottom: 1.875rem;
`;

export const SquareSupportFigure = styled.figure`
  z-index: 1;
  ${props =>
    props.breakpoint !== 'phone'
      ? `
    width: 70.8333333333333%;
    height: 73.1182795698925%;
    top: 14.58333333333335%;
    left: 14.58333333333335%;
    `
      : `
    width: 100%;
    height: 100%;
    top: 0%;
    left: 0%;
  `} position: absolute;

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const SupportFigure = styled.figure`
  z-index: 2;
  width: ${props =>
    props.breakpoint === 'desktop' ? 57.2631578947368 : 42.9473684210526}%;
  padding-top: ${props =>
    props.breakpoint === 'desktop' ? 42.9473684210526 : 32.21052631578945}%;
  position: absolute;
  top: 67.4342105263158%;
  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const SupportFigureLeft = SupportFigure.extend`
  left: -17.3684210526316%;
`;

export const SupportFigureRight = SupportFigure.extend`
  right: -17.3684210526316%;
`;

export const SquareSupportFigureLeft = SupportFigure.extend`
  width: 87.3529411764706%;
  padding-top: 62.0588235294118%;
  left: -39.7058823529412%;
  top: 73.5294117647059%;
`;

export const SquareSupportFigureRight = SupportFigure.extend`
  width: 87.3529411764706%;
  padding-top: 62.0588235294118%;
  right: -39.7058823529412%;
  top: 73.5294117647059%;
`;

const SupportFigurePortrait = SupportFigure.extend`
  width: 32.6315789473684%;
  padding-top: 43.5087719298246%;
  top: 63.8157894736842%;
`;

export const SupportFigurePortraitLeft = SupportFigurePortrait.extend`
  left: -16.3157894736842%;
`;

export const SupportFigurePortraitRight = SupportFigurePortrait.extend`
  right: -16.3157894736842%;
`;
/*
export const SupportImage = styled.figure`
  width: 100%;
  height: 100%;
`;
*/
const TriangleFigure = styled.figure`
  position: absolute;
  bottom: 0;
  width: 12.625rem;
  height: auto;

  div {
    width: 100%;
    height: 100%;
  }
`;

export const TriangleFigureLeft = TriangleFigure.extend`
  transform: translate3d(-50%, 30%, 0);
  left: 0;
`;

export const TriangleFigureRight = TriangleFigure.extend`
  transform: translate3d(50%, 30%, 0);
  right: 0;
`;

export const TriangleFigureCenter = TriangleFigure.extend`
  left: 50%;
  transform: translate3d(-50%, 50%, 0);
`;

const Triangle = props => {
  return (
    <svg className={props.className} viewBox="0 0 202 148">
      <defs>
        <linearGradient
          xmlns="http://www.w3.org/2000/svg"
          id="triangleGradient"
          gradientUnits="userSpaceOnUse"
          x1="99.9999"
          y1="-1.8904"
          x2="100.0095"
          y2="144.1084"
        >
          <stop offset="4.012986e-07" style={{ stopColor: '#D5DEF2' }} />
          <stop offset="0.459" style={{ stopColor: '#E5DBD9' }} />
          <stop offset="1" style={{ stopColor: '#F6D7C0' }} />
        </linearGradient>
      </defs>
      <polygon points="0,0 202,0 101,148" fill="url(#triangleGradient)" />
    </svg>
  );
};

export const TriangleImage = styled(Triangle)`
  width: 100%;
  height: 100%;
`;

const HeaderBlock = styled(ColumnBlock).attrs({
  columns: 2,
})`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
  position: absolute;
  z-index: 1;
  `};
`;

export const HeaderBlockRight = HeaderBlock.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
      right: 0;
    `};
`;

export const HeaderBlockLeft = HeaderBlock.extend`
  ${props =>
    props.breakpoint !== 'phone' &&
    `
    left: 0;
  `};
`;

export const HeaderContentLeft = styled(ColumnContent).attrs({
  paddingLeft: props =>
    props.breakpoint === 'desktop' ? '12.0rem' : '5.625rem',
  paddingRight: '3.75rem',
  //paddingRight: '10.5rem',
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '7.5rem'),
})`
  h2 {
    font-size: ${props => (props.breakpoint !== 'phone' ? 6.5 : 3.5)}rem;
  }
`;

export const HeaderContentRight = styled(ColumnContent).attrs({
  paddingLeft: props =>
    props.breakpoint === 'desktop' ? '14.5rem' : '3.75rem',
  paddingRight: '3.75rem',
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '7.5rem'),
})`
  h2 {
    font-size: ${props => (props.breakpoint !== 'phone' ? 6.5 : 3.5)}rem;
  }
`;

export const SplitHeaderContentLeft = styled(ColumnContent).attrs({
  paddingTop: '0',
  paddingRight: props => (props.breakpoint === 'tablet' ? '8.75rem' : '12rem'),
  paddingLeft: '10.5rem',
})`
  h2 {
    font-size: ${props => (props.breakpoint !== 'phone' ? 6.5 : 3.5)}rem;
  }
`;

export const SplitHeaderContentRight = styled(ColumnContent).attrs({
  paddingTop: '0',
  paddingLeft: props => (props.breakpoint === 'tablet' ? '8.75rem' : '12rem'),
  paddingRight: '10.5rem',
})`
  h2 {
    font-size: ${props => (props.breakpoint !== 'phone' ? 6.5 : 3.5)}rem;
  }
`;

export const TextBlock = styled(ColumnBlock).attrs({
  columns: 2,
})``;
/*
export const TextBlockPortraitLeft = TextBlock.extend`
  left: ${props => (props.breakpoint === 'phone' ? 0 : '25%')};
  `;
  */
export const TextBlockPortraitLeft = styled(ColumnBlock).attrs({
  columns: props => (props.breakpoint === 'tablet' ? 2.5 : 2),
})`
  left: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? '12.5%' : '25%'};
`;
//export const TextBlockPortraitRight = TextBlock.extend`
export const TextBlockPortraitRight = styled(ColumnBlock).attrs({
  columns: props => (props.breakpoint === 'tablet' ? 2.5 : 2),
})`
  right: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props.breakpoint === 'tablet' ? '12.5%' : '25%'};
`;

export const TextContentLeft = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: '5.625rem',
  paddingRight: props =>
    props.breakpoint === 'desktop' ? '18.75rem' : '3.75rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;

export const TextContentRight = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: props =>
    props.breakpoint === 'desktop' ? '13.755rem' : '3.75rem',
  paddingRight: props =>
    props.breakpoint === 'desktop' ? '10.625rem' : '5.625rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;

export const TextContentPortraitLeft = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: '3.75rem',
  paddingRight: '20.625rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;

export const TextContentPortraitRight = styled(ColumnContent).attrs({
  paddingTop: props => (props.breakpoint === 'phone' ? 0 : '4.5rem'),
  paddingLeft: '20.625rem',
  paddingRight: '3.75rem',
})`
  min-height: ${props => (props.breakpoint !== 'phone' ? '25rem' : 'unset')};
`;



// WEBPACK FOOTER //
// ./src/modules/pages/components/sections/ui.js